export default {
  sections: {
    order_summary: 'Resumen del pedido',
  },
  labels: {
    add_items: 'Añade artículos para empezar',
    item_count_one: '{{count}} artículo',
    item_count_other: '{{count}} artículos',
  },
  buttons: {
    return: 'Volver',
  },
  tip: 'Propina',
};
